import { usePostMutation } from "@/api/swr/useMutation";
import { companyMemberResetPasswordSchema } from "@/schema/app/profile/CompanyUser";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<typeof companyMemberResetPasswordSchema, z.ZodUndefined>>[3];

export const useResetCompanyMemberPassword = (
  id: number,
  config?: Config
) => {
  return usePostMutation(
    companyMemberResetPasswordSchema,
    z.undefined(),
    `/console/company_users/${id}/reset_password`,
    config,
  );
};
